import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import '../styles/upcomingMovies.scss';
import Title from './common/Title';

const UpcomingMoviesSkeleton = () => {
  return (
    <div className="upcoming-movies-container">
      <div className="container">
        <Title text="UPCOMING MOVIES" />
        <div className="upcoming-movies-tabs">
          <Skeleton width={120} height={40} />
          <Skeleton width={120} height={40} />
        </div>

        {/* Desktop Grid */}
        <div className="d-none d-md-flex row">
          {Array.from({ length: 4 }).map((_, idx) => (
            <div key={idx} className="col-md-3 d-flex justify-content-center">
              <div className="upcoming-movie-card">
                <div className="upcoming-movie-image-wrapper">
                  <Skeleton height={250} width="100%" />
                  <div className="upcoming-movie-trailer">
                    <Skeleton width={100} height={30} />
                    <Skeleton width={100} height={30} />
                  </div>
                </div>
                <div className="upcoming-movie-card-content">
                  <Skeleton width="80%" height={20} />
                  <Skeleton width="60%" height={15} />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Mobile Carousel */}
        <div className="d-md-none">
          <div className="carousel slide">
            <div className="carousel-inner">
              {Array.from({ length: 4 }).map((_, idx) => (
                <div key={idx} className={`carousel-item ${idx === 0 ? 'active' : ''}`}>
                  <div className="upcoming-movie-card">
                    <div className="upcoming-movie-image-wrapper">
                      <Skeleton height={250} width="100%" />
                      <div className="upcoming-movie-trailer">
                        <Skeleton width={100} height={30} />
                        <Skeleton width={100} height={30} />
                      </div>
                    </div>
                    <div className="upcoming-movie-card-content">
                      <Skeleton width="80%" height={20} />
                      <Skeleton width="60%" height={15} />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="upcoming-movies-viewall-row">
          <Skeleton width={100} height={40} />
        </div>
      </div>
    </div>
  );
};

export default UpcomingMoviesSkeleton;
